var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22082 11.7574L5.99954 10.7306L8.97276 12.447C9.53933 12.7741 10.4579 12.7741 11.0245 12.447L13.9977 10.7306L15.7764 11.7574L9.99862 15.093L4.22082 11.7574ZM15.2968 9.98063L17.5085 11.2575C17.9868 11.5336 17.9868 11.9813 17.5085 12.2574L10.8647 16.0929C10.3864 16.369 9.61088 16.369 9.13258 16.0929L2.48873 12.2574C2.01043 11.9813 2.01043 11.5336 2.48873 11.2575L4.70047 9.98063L2.64855 8.79606C2.08198 8.46898 2.08198 7.93868 2.64855 7.6116L8.97276 3.96063C9.53933 3.63355 10.4579 3.63355 11.0245 3.96063L17.3487 7.6116C17.9153 7.93868 17.9153 8.46898 17.3487 8.79606L15.2968 9.98063ZM4.70027 8.20383L9.99862 5.14509L15.297 8.20383L9.99862 11.2626L4.70027 8.20383Z",
    fill: "#191924"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.e69368d1e035dbdc51787704156c3914.svg";
export { ForwardRef as ReactComponent };